module.exports = __webpack_public_path__ + "static/line_start-d18349ea345caeba02ca6cdbb64c3fc0.mp4";